
/**
 * Map-specific style constants controlling the widths of the map tools panel and map search widget.
 */
export const mapStyleConstants = {
  mapToolsWidth: 350,
  mapSearchWidth: 500
}

/**
 * Internal shared style constants for component sizing, spacing, and color defaults — consumed by lightMode and darkMode spread.
 */
const componentStyleConstants = {
  detailsTitleFontSize: '64px',
  detailsTitleFontFamily: 'Arial',
  detailsTitleOffset: 50,
  borderWidth: '3px',
  borderWidthSm: '1px',
  cardMarginTop: 20,
  headerBorderBottom: 'none',
  appHeaderHeight: 70,
  appFooterHeight: 50,
  headerHeight: 70,
  footerHeight: 50,
  aimFullHeightFooterHeight: 110,
  detailsComponentOffset: 75,
  detailsTabsHeight: 103,
  logoHeight: 60,
  containerHeight: '100vh',
};

/**
 * Dark theme configuration with colors, fonts, and sizing constants for all UI components.
 */
export const darkMode = {
  theme: 'dark',
  textColor: 'white',
  detailsTitleColor: 'white',
  detailsOverviewItemTitleColor: 'lightgray',
  borderColor: 'white',
  iconColor: 'white',
  bgColor: 'rgba(79,91,93,255)',
  cardColor: 'rgb(107, 125, 126)',
  headerColor: 'rgba(79,91,93,255)',
  aimHeaderColor: 'rgba(79,91,93,255)',
  tableHeaderColor: 'rgba(79,91,93,255)',
  mapPopouButtonColor: 'rgba(79,91,93,255)',
  footerColor: '#3E4849',
  imgLoaderBg: '#dee2e6',
  ...componentStyleConstants
};

/**
 * Light theme configuration with colors, fonts, and sizing constants for all UI components.
 */
export const lightMode = {
  theme: 'light',
  textColor: '#3b3b3b',
  detailsTitleColor: 'white',
  detailsOverviewItemTitleColor: '#636363',
  detailsOverviewItemUnderlineColor: '#e0e0e0',
  // borderColor: '#e0e0e0',
  borderColor: '#636363',
  iconColor: '#636363',
  bgColor: 'white',
  cardColor: 'white',
  headerColor: 'white',
  aimHeaderColor: 'white',
  mapPopoutButtonColor: '#F2F2F2',
  footerColor: 'white',
  tableHeaderColor: '#C4C4C4',
  imgLoaderBg: '#dee2e6',
  ...componentStyleConstants
};